import React from "react";

import { Typography } from "@material-ui/core";

export const ServiceHelp = () => {
  return (
    <>
      <Typography variant="subtitle1">
        Enter pricing per Unit of inventory / goods quantity. This information
        will be used for invoicing.
      </Typography>
      <ul>
        <li>
          <Typography>
            <strong>Service Name:</strong> Keep it short, 1-3 words. Service
            name cannot be changed once record is saved.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Description:</strong> Short service description.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>
              UNIT / PCS / CAR / TL / MBF / LF / SF / GAL / LBS / TON / CWT:
            </strong>{" "}
            Enter pricing for relevant Units of measure.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Service Availability:</strong> Mark service as un-available
            if not relevant to your yard. E.g. mark "inside Handling" as
            "Suspended" if you have no warehouse facilities, or if service is
            temporarily not available.
          </Typography>
        </li>
      </ul>
    </>
  );
};
